import React from 'react';
import {
    AddContainer,
    Component4,
    Texts,
    Component2,
    InnerComponent,
    RemoveButton,
    SaveButton,
    LabelWithTooltip
} from './Styles';
import { Formik, Form, FieldArray } from 'formik';
import InputSelect from 'src/components/shared/Form/Select';
import DateTimePicker from 'src/components/App/DatePicker';
import theme from 'src/config/theme';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { ReactComponent as Remove } from '../../../../../assets/images/close-circle.svg';
import { getUserFromToken } from 'src/DecodeToken';
import { ReactComponent as Add } from '../../../../../assets/images/add-square.svg';
import useResponsive from 'src/components/hooks/useResponsive';

dayjs.extend(customParseFormat);


const Days = [
    { label: 'Monday', value: 'monday' },
    { label: 'Tuesday', value: 'tuesday' },
    { label: 'Wednesday', value: 'wednesday' },
    { label: 'Thursday', value: 'thursday' },
    { label: 'Friday', value: 'friday' },
    { label: 'Saturday', value: 'saturday' },
    { label: 'Sunday', value: 'sunday' },
];

const ClinicTimingStep = ({ data = [], innerRef, setClinicProfileData }) => {
    const { isMobile, isTablet } = useResponsive();
    const Width = isMobile || isTablet ? '18px' : '24px';
    const Height = isMobile || isTablet ? '18px' : '24px';
    const userId = getUserFromToken();

    const parseTime = (timeStr) => {
        if (!timeStr) return null;
        if (timeStr instanceof Date) {
            return dayjs(timeStr).year(2026).month(0).date(1).second(0).millisecond(0).toDate();
        }
        if (dayjs.isDayjs(timeStr)) {
            return timeStr.year(2026).month(0).date(1).second(0).millisecond(0).toDate();
        }

        // Try standard parsing first
        const stdParsed = dayjs(timeStr);
        if (stdParsed.isValid() && !/^\d{2}:\d{2}/.test(timeStr)) {
            return stdParsed.year(2026).month(0).date(1).second(0).millisecond(0).toDate();
        }

        // Try custom formats
        const normalized = timeStr.replace(/\./g, '').toUpperCase();
        const formats = ['h A', 'h:mm A', 'hh:mm A', 'HH:mm', 'hA', 'ha', 'hh:mm aa'];
        for (let format of formats) {
            const parsed = dayjs(normalized, format, true);
            if (parsed.isValid()) {
                return parsed.year(2026).month(0).date(1).second(0).millisecond(0).toDate();
            }
        }
        return null;
    };
    const initialValues = {
        clinicTiming: data.length > 0
            ? data.map(item => ({
                ...item,
                startTime: parseTime(item.startTime),
                endTime: parseTime(item.endTime),
                user: userId,
            }))
            : [{ day: '', startTime: null, endTime: null }],
    };


    const handleSubmit = (values) => {
        const formattedTiming = values.clinicTiming.map(item => ({
            ...item,
            startTime: item.startTime ? new Date(item.startTime).toISOString() : '',
            endTime: item.endTime ? new Date(item.endTime).toISOString() : '',
        }));

        setClinicProfileData(prev => ({
            ...prev,
            clinicTiming: formattedTiming,
        }));
    };


    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            innerRef={innerRef}
            enableReinitialize
        >
            {({ values, setFieldValue }) => (
                <Form>
                    <AddContainer sx={{ gap: '20px', paddingLeft: isMobile || isTablet ? 'auto' : '0 !important', paddingRight: isMobile || isTablet ? 'auto' : '0 !important' }}>
                        <FieldArray name="clinicTiming">
                            {({ push, remove }) => (
                                <>
                                    {values.clinicTiming.map((timing, index) => (

                                        <Component2 key={index} sx={{ alignItems: 'center' }}>
                                            <InnerComponent>
                                                <Texts>
                                                    <LabelWithTooltip label="Day" tooltip="Select the day when the doctor is available." />
                                                </Texts>
                                                <InputSelect
                                                    name={`clinicTiming.${index}.day`}
                                                    options={Days}
                                                    value={timing.day}
                                                    onChange={(val) =>
                                                        setFieldValue(`clinicTiming.${index}.day`, val)
                                                    }
                                                    placeholder="Select"
                                                    variant="outlined"
                                                    sx={{
                                                        boxShadow: theme.shadows[1],
                                                        '& .MuiOutlinedInput-root': {
                                                            height: '52px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            borderRadius: '12px',
                                                        },
                                                    }}
                                                />
                                            </InnerComponent>
                                            <InnerComponent>
                                                <Texts>
                                                    <LabelWithTooltip label="Start Time" tooltip="Select the time when the clinic session starts." />
                                                </Texts>
                                                <DateTimePicker
                                                    type="time"
                                                    value={timing.startTime}
                                                    onChange={(val) =>
                                                        setFieldValue(`clinicTiming.${index}.startTime`, val)
                                                    }
                                                />
                                            </InnerComponent>

                                            <InnerComponent>
                                                <Texts>
                                                    <LabelWithTooltip label="End Time" tooltip="Select the time when the clinic session ends." />
                                                </Texts>
                                                <DateTimePicker
                                                    type="time"
                                                    value={timing.endTime}
                                                    onChange={(val) =>
                                                        setFieldValue(`clinicTiming.${index}.endTime`, val)
                                                    }
                                                />
                                            </InnerComponent>

                                            <RemoveButton

                                                onClick={() => remove(index)}
                                                sx={{ mt: isMobile ? "5px" : 3 }}
                                            >
                                                <Remove width={Width} height={Height} />
                                            </RemoveButton>
                                        </Component2>

                                    ))}

                                    <Box display="flex" justifyContent="flex-end" mt={2}>
                                        <SaveButton
                                            variant="outlined"
                                            onClick={() => push({ day: '', startTime: null, endTime: null })}
                                            startIcon={<Add width={Width} height={Height} sx={{ color: theme.palette.primary.main }} />}

                                        >Add </SaveButton>
                                    </Box>

                                </>
                            )}
                        </FieldArray>
                    </AddContainer>
                </Form >
            )
            }
        </Formik >
    );
};

export default ClinicTimingStep;
